import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  Button,
  Modal,
  Row,
  Col,
  Form,
  Dropdown,
  Image,
} from "react-bootstrap";
import { BiImage } from "react-icons/bi";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import moment from "moment";

function showLoader() {
  const loaderHTML = `
    <div id="processingModal" class="modal fade show d-block" style="background: rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2 text-white">Loading...</p>
          </div>
        </div>
      </div>
    </div>
  `;
  if (document) {
    document.body.insertAdjacentHTML("beforeend", loaderHTML);
  }
}
function hideLoader() {
  const loader = document.getElementById("processingModal");
  if (loader) loader.remove();
}

const MediaGrid = ({ viewAsGrid, setViewAsGrid, onDrop, onDragOver }) => {
  const [media, setMedia] = useState([]);
  const [filteredMedia, setFilteredMedia] = useState([]);
  const [viewMedia, setViewMedia] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: "created_at",
    direction: "desc",
  });

  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state?.userInfo);
  const formatDate =
    userInfo?.account_preferences?.date_formate || "DD MMM, YYYY";

  useEffect(() => {
    fetchMedia();
  }, [viewAsGrid]);

  const fetchMedia = async () => {
    try {
      showLoader();
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_FETCH_MEDIA}`,
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
          },
        }
      );
      hideLoader();
      setMedia(response.data?.data);
      setFilteredMedia(response.data?.data);
    } catch (error) {
      console.error("Error fetching media:", error);
    }
  };

  useEffect(() => {
    let updatedList = [...media];

    // Filter by search term
    if (searchTerm) {
      updatedList = updatedList.filter((item) =>
        item.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Sorting
    updatedList.sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key])
        return sortConfig.direction === "asc" ? -1 : 1;
      if (a[sortConfig.key] > b[sortConfig.key])
        return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });

    setFilteredMedia(updatedList);
  }, [searchTerm, media, sortConfig]);

  // Handle pagination
  const paginatedMedia = filteredMedia?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleExport = (format) => {
    switch (format) {
      case "Excel":
        break;
      case "CSV":
        break;
      case "PDF":
        break;
      default:
        console.error("Invalid export format");
    }
  };
  const handleRowPerPage = (value) => {
    showLoader();
    setItemsPerPage(value);
    setTimeout(() => {
      hideLoader();
    }, 800);
  };
  const handlePagination = (page) => {
    showLoader();
    setCurrentPage(page);
    setTimeout(() => {
      hideLoader();
    }, 500);
  };
  return (
    <>
      <h3 className="m-0">Media</h3>
      <div
        className="drag-drop-area mt-4"
        style={{
          border: 0,
        }}
      >
        <Row className="m-0 g-2">
          <Col xs={12}>
            <Card className="border-0 shadow-sm">
              <Card.Body>
                <div
                  className="m-0 mb-3 rounded-1 d-flex flex-column align-items-center justify-content-center"
                  onDrop={onDrop}
                  onDragOver={onDragOver}
                  style={{
                    borderWidth: "1px",
                    borderStyle: "dotted",
                    borderColor: "gray",
                  }}
                >
                  <BiImage
                    className="text-gray text-muted"
                    style={{ fontSize: "3rem" }}
                  />
                  <small className="text-muted" style={{ fontSize: "1rem" }}>
                    Drag and Drop Files Here
                  </small>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-3">
                  {/* Show Entries Dropdown */}
                  <div className="d-flex">
                    <Dropdown autoClose="outside">
                      <Dropdown.Toggle
                        variant="secondary"
                        size="sm"
                        style={{
                          borderBottomRightRadius: "0px",
                          borderTopRightRadius: "0px",
                        }}
                      >
                        Show{" "}
                        {itemsPerPage === filteredMedia?.length
                          ? "all"
                          : itemsPerPage}{" "}
                        rows
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="p-0 overflow-hidden">
                        <Dropdown.Item onClick={() => handleRowPerPage(10)}>
                          10 rows
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleRowPerPage(20)}>
                          20 rows
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleRowPerPage(50)}>
                          50 rows
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleRowPerPage(100)}>
                          100 rows
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleRowPerPage(500)}>
                          500 rows
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() =>
                            handleRowPerPage(filteredMedia?.length)
                          }
                        >
                          Show all
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <Button
                      variant="secondary"
                      size="sm"
                      style={{
                        borderBottomLeftRadius: "0px",
                        borderTopLeftRadius: "0px",
                        borderLeft: 0,
                      }}
                      onClick={() => setViewAsGrid(false)}
                    >
                      List view
                    </Button>
                  </div>
                  {/* Search Bar */}
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: "186px" }}
                  />
                </div>

                {/* Grid Layout for Media Files */}
                <Row
                  style={{
                    border: "1px solid #efecf3",
                    paddingRight: "8px",
                  }}
                >
                  {paginatedMedia.map((item, index) => (
                    <Col
                      sm={3}
                      style={{ cursor: "pointer", paddingLeft: "0px" }}
                      key={index}
                      onClick={() => setViewMedia(item.url)}
                    >
                      <OverlayTrigger
                        key={index}
                        // placement="top"
                        overlay={
                          <Tooltip id="button-tooltip">
                            <p style={{ fontSize: "14px" }}>
                              <b>Description: </b>
                              {item.title}
                            </p>
                            <p style={{ fontSize: "14px" }}>
                              <b>Created On: </b>
                              {`${moment(
                                item["created_at"] || item["updated_at"]
                              ).format(
                                `${
                                  formatDate === null ||
                                  formatDate === undefined
                                    ? "DD MMM, YYYY"
                                    : formatDate
                                }`
                              )}`}
                            </p>
                          </Tooltip>
                        }
                      >
                        <Card
                          key={index}
                          style={{ width: "95%", padding: 10, height: "200px" }}
                          className="col-md-2 m-3"
                        >
                          <Card.Img
                            src={`${process.env.REACT_APP_API_BASE_URL?.replace(
                              "/api",
                              "/public/uploads"
                            )}${item.url}`}
                            alt={item.title}
                            className="img-thumbnail"
                            style={{
                              cursor: "pointer",
                              height: "150px",
                              objectFit: "cover",
                            }}
                            onClick={() => setViewMedia(item.url)}
                          />
                          <hr />
                          <Card.Text
                            className="text-center mt-1 mx-1"
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {item.title}
                          </Card.Text>
                        </Card>
                      </OverlayTrigger>
                    </Col>
                  ))}
                </Row>

                {/* Pagination Controls */}
                <div className="d-flex justify-content-between align-items-center mt-4">
                  <span>
                    Showing{" "}
                    {filteredMedia.length === 0
                      ? 0
                      : (currentPage - 1) * itemsPerPage + 1}{" "}
                    to{" "}
                    {Math.min(currentPage * itemsPerPage, filteredMedia.length)}{" "}
                    of {filteredMedia.length} entries
                  </span>
                  <div>
                    <Button
                      variant="light"
                      size="sm"
                      disabled={currentPage === 1}
                      onClick={() => handlePagination(currentPage - 1)}
                    >
                      <FaArrowLeft className="text-xl cursor-pointer" />
                    </Button>

                    {[...Array(Math.ceil(filteredMedia.length / itemsPerPage))]
                      .map((_, i) => i + 1)
                      .filter(
                        (page) =>
                          page === 1 ||
                          page ===
                            Math.ceil(filteredMedia.length / itemsPerPage) ||
                          (page >= currentPage - 2 && page <= currentPage + 2)
                      )
                      .reduce((acc, page, i, arr) => {
                        if (i > 0 && page !== arr[i - 1] + 1) acc.push("...");
                        acc.push(page);
                        return acc;
                      }, [])
                      .map((page, i) =>
                        page === "..." ? (
                          <span key={i} className="mx-1">
                            …
                          </span>
                        ) : (
                          <Button
                            key={i}
                            style={{
                              width: "32px",
                              height: "34px",
                              borderRadius: "50%",
                            }}
                            variant={currentPage === page ? "primary" : "light"}
                            className="mx-1"
                            size="sm"
                            onClick={() => handlePagination(page)}
                          >
                            {page}
                          </Button>
                        )
                      )}

                    <Button
                      variant="light"
                      size="sm"
                      disabled={
                        currentPage ===
                        Math.ceil(filteredMedia.length / itemsPerPage)
                      }
                      onClick={() => {
                        handlePagination(currentPage + 1);
                      }}
                    >
                      <FaArrowRight className="text-xl cursor-pointer" />
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
      {/* Modal to View Image */}
      <Modal show={!!viewMedia} onHide={() => setViewMedia(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Media</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          <Image
            src={`${process.env.REACT_APP_API_BASE_URL?.replace(
              "/api",
              "/public/uploads"
            )}${viewMedia}`}
            alt="img"
            class="img-thumbnail "
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MediaGrid;
